const ready = require('./utilities').ready;

const JOIN_PATH = '/join';

ready(init);

function init() {
  document.querySelectorAll('.js-oauth-sign-in').forEach((button) => {
    button.addEventListener('click', handleOAuthClick);
  });
}

async function handleOAuthClick(event) {
  event.preventDefault();

  const button = event.currentTarget;
  const oauthPath = button.dataset.oauthPath;
  if (!oauthPath) {
    redirectToFallback(button);
    return;
  }

  button.disabled = true;

  try {
    const response = await fetch(JOIN_PATH, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    });

    if (!response.ok) {
      throw new Error('csrf fetch failed');
    }

    const csrfToken = extractCsrfToken(await response.text());
    if (!csrfToken) {
      throw new Error('csrf missing');
    }

    submitOAuthForm(oauthPath, csrfToken);
  } catch (_error) {
    redirectToFallback(button);
  }
}

function redirectToFallback(button) {
  const fallbackHref = button.dataset.fallbackHref;
  if (fallbackHref) {
    window.location = fallbackHref;
    return;
  }

  button.disabled = false;
}

function extractCsrfToken(html) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector('meta[name="csrf-token"]')
    ?.content;
}

function submitOAuthForm(oauthPath, csrfToken) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = oauthPath;

  const csrfInput = document.createElement('input');
  csrfInput.type = 'hidden';
  csrfInput.name = 'authenticity_token';
  csrfInput.value = csrfToken;
  form.appendChild(csrfInput);

  document.body.appendChild(form);
  form.submit();
}
